module.exports = __webpack_public_path__ + "static/media/bg-welcome.5bfda745.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/appointment/components/images/bg-welcome.png
// module id = 898
// module chunks = 0